export class ConditionExpressionPlainObject {
    public leftExpression: string;
    public rightExpression: string;
    public conditionType: string;
}
